import { WorkflowItemTypes } from '../enums';

export interface GlobalSearchModel {
  id: number;
  recordId: string;
  workflowItemTypeValue: WorkflowItemTypes;
  orderRequestId: number;
  addedDateTime: string;
}
